export default __webpack_public_path__ + "static/media/gallery_02.1c7cac47.jpg";